/**
 * 应用中心积分设置模块
 */
export const ApplyPointArr = [
  {
    path: "point/:id(\\d+)",
    name: "point/:id(\\d+)",
    meta: {
      title: "积分"
    },
    redirect: "/apply/point/:id(\\d+)/pointSetting",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "pointSetting",
        name: "pointSetting",
        meta: {
          title: "积分设置"
        },
        component: () => import("@/views/apply/pointSetting/pointSetting")
      }
    ]
  }
];
